module.exports = __webpack_public_path__ + "media/images/samples/news/article-img-9c383ca09e067db1fc41da5ccd927474.png";